import styled from 'styled-components';
import { Card } from '../../style';

export const StyledPlanCard = styled(Card)`
  grid-column: span 6;
  display: flex;
  flex-direction: column;
  padding: 24px;

  @media (max-width: 1200px) {
    grid-column: span 12;
  }
`;

export const PlanHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center; /* Changed from flex-start to center for badge alignment */
  margin-bottom: 24px;
`;

export const PlanTitleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const PlanTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  .icon-container {
    width: 44px;
    height: 44px;
    background: #E8EEFB; /* More accurate light blue from design */
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;

    img {
      width: 24px;
      height: 24px;
    }
  }

  h2 {
    font-size: 22px;
    font-weight: 700;
    color: #1a1a1a;
    margin: 0;
  }
`;

export const PlanBadge = styled.span`
  background: #E8F5E9; /* Lighter, cleaner green background */
  color: #4CAF50; /* Standard material green for text */
  padding: 6px 16px;
  border-radius: 20px; /* Pill shape */
  font-size: 13px;
  font-weight: 700;
  height: fit-content;
`;

export const PlanPrice = styled.div`
  font-size: 14px;
  color: #666;
  font-weight: 500;
  margin-left: 60px; /* Align with text after icon */

  span {
    color: #5E8E7E;
    font-weight: 700;
    font-size: 18px;
  }
`;

export const PlanDates = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #F8F9F8; /* Original beige/grey background from design */
  padding: 16px 24px;
  border-radius: 12px;
  margin-bottom: 24px;
`;

export const DateItem = styled.div<{ isRed?: boolean; align?: 'left' | 'center' | 'right' }>`
  text-align: ${({ align }) => align || 'left'};

  h4 {
    font-size: 11px;
    color: #8E8E93;
    margin: 0 0 4px 0;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  p {
    font-size: 15px;
    font-weight: 700;
    color: ${({ isRed }) => isRed ? '#D94D4D' : '#1A1A1A'};
    margin: 0;
  }
`;

export const ProgressSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 24px;
`;

export const ProgressItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ProgressLabels = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: #666; /* Lighter grey for labels */
  font-weight: 500;
`;

export const ProgressBarBg = styled.div`
  height: 6px;
  background: #E5E7EB;
  border-radius: 10px;
  overflow: hidden;
`;

export const ProgressBarFill = styled.div<{ width: string; color: string }>`
  height: 100%;
  width: ${({ width }) => width};
  background-color: ${({ color }) => color};
  border-radius: 10px;
  transition: width 0.5s ease;
`;

export const UpgradeBtnWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
`;

export const UpgradeBtn = styled.button`
  padding: 12px 32px;
  background: #5E8E7E;
  color: #fff;
  border: none;
  border-radius: 10px;
  font-weight: 700;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #4d7a6a;
  }
`;
